const REQUEST_LEADERS = '@@leaders/REQUEST_LEADERS';
const LEADERS_RESPONSE = '@@leaders/LEADERS_RESPONSE';

export default {
    REQUEST_LEADERS,
    LEADERS_RESPONSE,
};
